<template>
<router-view/>
</template>

<script>
  export default {
   name: 'ServicesComp'
  }
</script>